/**
 * Central tuning constants for the TWCG-2055 "Flag to Share" experiment.
 *
 * Kept in one module so the criteria evaluator, the inactivity timer, and tests
 * all reference the same source of truth.
 */

/**
 * How long editing must stay idle after the criteria are met before the nudge
 * fires. The timer resets on every new progress signal.
 */
export const INACTIVITY_MS = 2_500;

/**
 * Shared first-trigger threshold. Applied to every content type's *first*
 * "criteria met" trigger (i.e. before the persisted triggered-types state has
 * recorded that content type as having fired before). One unit of progress
 * (one word, one element, one row, or one filled cell) is enough to qualify.
 */
export const FIRST_THRESHOLD = 1;

/** Live Docs (subsequent trigger): words written (delta) required to meet the share criteria. */
export const LIVE_DOC_WORDS = 100;

/**
 * Database (subsequent trigger): criteria met when more than `DB_ROWS` rows are created AND at
 * least one cell is filled, OR when more than `DB_CELLS` cells are filled. Values are
 * exclusive thresholds (i.e. `> DB_ROWS` / `> DB_CELLS`).
 */
export const DB_ROWS = 3;
export const DB_CELLS = 3;

/** Whiteboard (subsequent trigger): objects added required to meet the share criteria. */
export const WHITEBOARD_OBJECTS = 3;
